export default __webpack_public_path__ + "static/media/producto2.3ac42652.svg";